import { render } from "./ImporAtletPage.vue?vue&type=template&id=0f0422e7&scoped=true"
import script from "./ImporAtletPage.vue?vue&type=script&lang=js"
export * from "./ImporAtletPage.vue?vue&type=script&lang=js"

import "./ImporAtletPage.vue?vue&type=style&index=0&id=0f0422e7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0422e7"]])

export default __exports__